import React, { PureComponent } from "react"
import PropTypes from "prop-types"
import MultiSelector from "./MultiSelector"
import "./RevenueMultiSelector.css"
import Checkbox from "../Checkbox/Checkbox"

class RevenueMultiSelector extends PureComponent {
  state = {
    selectNoneObject: {
      label: "Ei tiedossa",
      value: {
        minRevenue: -1,
        maxRevenue: -1,
      },
    },
  }

  renderOptions = () => {
    const { handleChange, options, filters } = this.props
    if (options) {
      return options.map(o => (
        <li key={o.value.minRevenue}>
          <Checkbox
            label={o.label}
            id={o.label}
            onClick={() => handleChange(o, "revenue")}
            checked={filters.some(f => f.value.maxRevenue === o.value.maxRevenue)}
          />
        </li>
      ))
    }
    return null
  }

  renderSelectNone = () => {
    const { handleChange, filters } = this.props
    const { selectNoneObject } = this.state
    return (
      <li key="select-none">
        <Checkbox
          id="revenue-selector"
          label="Ei tiedossa"
          onClick={() => handleChange(selectNoneObject, "revenue")}
          checked={filters.some(f => f.value.minRevenue === -1)}
        />
      </li>
    )
  }

  render() {
    const { handleChange, options, filters, ...rest } = this.props
    const { selectNoneObject } = this.state
    let allOptions
    if (options) allOptions = options.concat(selectNoneObject)
    return (
      <div className="revenue-selector-wrapper">
        <MultiSelector
          text="Liikevaihto"
          filters={filters}
          filter="revenue"
          options={allOptions}
          target="revenue"
          handleChange={handleChange}
          {...rest}
        >
          <ul>
            {this.renderOptions()}
            {this.renderSelectNone()}
          </ul>
        </MultiSelector>
      </div>
    )
  }
}

RevenueMultiSelector.propTypes = {
  toggleSelector: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  filters: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  clearFilters: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape()),
}

export default RevenueMultiSelector
